import { useState, useEffect } from "react";

export const useCartCount = () => {
  const [count, setCount] = useState(0);

  const updateCount = () => {
    const cartData = localStorage.getItem("cartCache");
    if (cartData) {
      const parsed = JSON.parse(cartData);
      // Soma as quantidades de cada item (se tiver campo quantity)
      const total = parsed.reduce((sum, item) => sum + (item.quantity || 1), 0);
      setCount(total);
    } else {
      setCount(0);
    }
  };

  useEffect(() => {
    updateCount();

    // Atualiza quando o localStorage muda em outra aba
    window.addEventListener("storage", updateCount);

    // Cria um event listener customizado para atualizar na mesma aba
    const handleCartUpdate = () => updateCount();
    window.addEventListener("cartUpdated", handleCartUpdate);

    return () => {
      window.removeEventListener("storage", updateCount);
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  return { count, updateCount };
};
